import { render, staticRenderFns } from "./CNC_Machining.vue?vue&type=template&id=0a5d8cae&scoped=true"
import script from "./CNC_Machining.vue?vue&type=script&lang=js"
export * from "./CNC_Machining.vue?vue&type=script&lang=js"
import style0 from "./CNC_Machining.vue?vue&type=style&index=0&id=0a5d8cae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5d8cae",
  null
  
)

export default component.exports